import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IGetRestaurantAllPlacesResponseCli } from "@interfaces/IGetRestaurantAllPlacesResponseCli.ts"

export const GetRestaurantAllPlacesAdapter = (
	response: IApiResponse<IGetRestaurantAllPlacesResponseCli>
): IGetRestaurantAllPlacesResponseCli => {
	return response.data
}
